import { GetServerSidePropsContext } from 'next';
import { NextPage } from 'next';
import { useRouter } from 'next/router.js';
import React, { useMemo } from 'react';
import { cachedFetchPurchases } from '../../api/fetchPurchases.js';
import { PurchasesResponse } from '../../api/fetchPurchases.js';
import { AnnouncesIndexQuery } from '../../api/fetchPurchases.js';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext.js';
import { Purchases } from '../../components/Purchases/index.js';
import { Services } from '../../types.js';
import Meta from '../../components/Meta.js';
import { metaTags } from '../../components/_dummyData/index.js';
import { breadcrumbs } from '../../components/_dummyData/index.js';

const PurchasesPage: NextPage<PurchasesResponse> = ({
  announces,
  reference,
  orgSection,
  total,
  matches,
  selectableOptions,
}) => {
  const router = useRouter();

  const tags = useMemo(() => {
    if (orgSection?.orgTitle) {
      return {
        title: `Тендеры ${orgSection.orgTitle + metaTags.orgSection.title}`,
        description: `Тендеры ${
          orgSection.orgTitle + metaTags.orgSection.description
        }`,
        url: `${metaTags.orgSection.url + router.query.sectionOrg}`,
        breadcrumbs: [{ title: 'Закупки' }],
      };
    }

    if (typeof router.query.section === 'string') {
      return {
        title: metaTags[router.query.section].title,
        description: metaTags[router.query.section].description,
        url: metaTags[router.query.section].url,
        breadcrumbs: [
          { title: 'Закупки', href: '/purchases' },
          { title: breadcrumbs[router.query.section] },
        ],
      };
    }

    return {
      title: metaTags.purchases.title,
      description: metaTags.purchases.description,
      url: metaTags.purchases.url,
      breadcrumbs: [{ title: 'Закупки' }],
    };
  }, [orgSection?.orgTitle, router.query.section, router.query.sectionOrg]);

  useBreadcrumbs(tags.breadcrumbs, true, [tags.breadcrumbs]);

  return (
    <>
      <Meta title={tags.title} description={tags.description} url={tags.url} />
      <Purchases
        announces={announces}
        reference={reference}
        orgSection={orgSection}
        total={total}
        matches={matches}
        selectableOptions={selectableOptions}
      />
    </>
  );
};

export default PurchasesPage;

export const getServerSideProps = async (
  context: GetServerSidePropsContext<AnnouncesIndexQuery> & {
    req: { services: Services };
  },
) => {
  const props = await cachedFetchPurchases(context.query, context.req.services);
  return {
    props,
  };
};
